export const VanIcon = ({ className = "w-4 h-4", ...props }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true" {...props}>
    <path d="M1.5 17V5a2 2 0 0 1 2-2h9.5a7 7 0 0 1 7 7v7H1.5z" />
    <path d="M13 6.5h1.5a3 3 0 0 1 3 3V11H13z" />
    <path d="M20 16h3" />
    <circle cx="9" cy="19.5" r="2.5" fill="currentColor" stroke="none" />
  </svg>
);
